import { useEffect } from "react";

import { CrashGroupAddedEvent, ServerToClientEvents, SocketEvents } from "@common/models/webSocketEvents";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import { Socket } from "socket.io-client";

interface Params {
  socket?: Socket<ServerToClientEvents, never>;
  refetchData?: () => void;
}

export const useCrashGroupAddedSocketConsumer = ({ socket, refetchData }: Params) => {
  const { selectedApp } = useAppSelectionContext();
  useEffect(() => {
    if (!selectedApp || !socket) return;

    const eventHandler = (event: CrashGroupAddedEvent) => {
      if (event.app_id === selectedApp.id) refetchData?.();
    };

    socket.on(SocketEvents.CRASH_GROUP_ADDED, eventHandler);
    return () => {
      socket.off(SocketEvents.CRASH_GROUP_ADDED, eventHandler);
    };
  }, [socket, selectedApp, refetchData]);
};
